import { useMemo } from 'react';

import type { Option } from '@packages/utils/create-options/create-options';

export const useFormFieldSelectionTransform = (options: Option[]) =>
  useMemo(
    () => ({
      input: (value: string | undefined) =>
        options.find((option) => option.value === value) ?? null,
      output: (option: Option | null) => {
        return option?.value ?? '';
      },
    }),
    [options],
  );
